module.exports = __webpack_public_path__ + "static/media/img140.ca1766c5.jpg";